var defaultConfig = {
    slickActiveWidth: 993,
    slickDotsIsActive: false
};
